<template>
	<div class="list-item-search">
		<div class="itemSearch">
			<div v-if="!textshow&&!iszhuanti" class="itemSearch_form itemSearch_form_collapse">
				<div @click="showSearch()">
					<input class="search_input_lanmu" type="text" :placeholder="(iszhuanti?'当前专题':colname)+'内搜索'" />
					<button type="button" value="" class="search_btn1_lanmu" />
				</div>
			</div>
			<div v-else class="itemSearch_form">
				<div>
					<div style="display: inline-block;position: relative;">
						<input class="search_input_lanmu" type="text" :placeholder="(iszhuanti?'当前专题':colname)+'内搜索'" v-model="keyword" @focus="showsug(1)"
							@keyup="showsug(0)" @blur="hidesug()" @keypress.enter="searchClick()" />
						<i id="eClose" v-show="keyword" @click="clearword()"></i>
						<button type="button" value="" class="search_btn1_lanmu" @click="searchClick()" />
					</div>
					<input v-show="(!iszhuanti)||(iszhuanti&&resultshow)" type="button" value="关闭" @click="closeSearch()" class="search_close_lanmu" />
				</div>
				
				<div class="search_dropdown" v-show="showsugflag&&sugwordsList.length">
					<ul class="hotkeywords">
						<li v-for="(item,index) in sugwordsList" @mousedown="selhistory(item)">
							<btn
								v-html="item.replace(cachekeyword,'<span style=\'font-weight:bold;\'>'+cachekeyword+'</span>')">
							</btn>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div v-if="resultshow">
			<div v-if="(searchword&&totalResultCount)||loadingMask" v-loading="loadingMask">
				<div class="Tabnav_box">
					<!-- Tabnav_box -->
					<div class="Tabnav_box_L">
					</div>
					<div class="Tabnav_box_R2">

						<div id="datePanelDiv" class="Tabnav_out" name="Tabnav_out" @click="showDatePanel()">
							<!-- Tabnav_out -->
							<div class="Tabnav_screen2" name="Tabnav_screen">{{dateTypeText}}
								<!-- <img :src="datePanelVisible?'/images/dIcon.png':'/images/down.png'" style="margin-left: 10px;" /> -->
							</div>
							<!-- <el-collapse-transition> -->
							<ul class="Tabnav1" name="Tabnav" style="right: 0;" v-show="datePanelVisible">
								<li @click.stop="dateClick(0,'时间不限')" :class="dateType==0?'on':''">时间不限</li>
								<li @click.stop="dateClick(1,'一周内')" :class="dateType==1?'on':''">一周内</li>
								<li @click.stop="dateClick(2,'一月内')" :class="dateType==2?'on':''">一月内</li>
								<li @click.stop="dateClick(3,'一年内')" :class="dateType==3?'on':''">一年内</li>
								<li @click.stop="dateClick(4,'自定义')" :class="dateType==4?'on':''">
									<div>自定义</div>
									<div class="" v-on:click.stop>
										<el-date-picker v-model="dateStr" type="daterange" value-format="yyyy-MM-dd"
											range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
											@change="dateClick(4,'自定义')">
										</el-date-picker>
									</div>
								</li>

							</ul>
							<!-- </el-collapse-transition> -->
						</div><!-- /Tabnav_out -->

					</div>
				</div><!-- /Tabnav_box -->
				<div id="con_a_1">
					<div class="thematic_list  ">
						<section v-for="(result,index) in resultDataList" :key="result.id" style="margin-bottom: 48px;">
							<dl>
								<dd>
									<a target="_blank" style="font-weight: bold;" @click="jumppush('/detail/'+result.id+'?key='+searchword+'&col='+colfrom+'&s=s')" class="T-tit"
										v-html="result.title.replace(/color:Red/g,'color:#bd1a2d;font-weight:bold;')"></a>
								</dd>
							</dl>
							<dl v-if="result.content&&result.content.indexOf('.pdf</attachment>')>-1" style="margin: 24px 0px 16px 0px">
								<dd  style="white-space: normal; display: -webkit-box; overflow: hidden; text-overflow: ellipsis; -webkit-box-orient: vertical; -webkit-line-clamp: 3;">
									<a
										target="_blank" style="color: #a1a4ab;" @click="jumppush('/detail/'+resultHitList[index].id+'?key='+searchword+'&col='+colfrom+'&s=s')" 
										v-html="result.summary">
									</a>
								</dd>
							</dl>
							<dl v-else-if="resultHitList[index]&&resultHitList[index].hitPara&&resultHitList[index].hitPara.length>0" style="margin: 24px 0px 16px 0px">
								<dd  style="white-space: normal; display: -webkit-box; overflow: hidden; text-overflow: ellipsis; -webkit-box-orient: vertical; -webkit-line-clamp: 3;">
									<a
										target="_blank" style="color: #a1a4ab;" @click="jumppush('/detail/'+resultHitList[index].id+'?key='+searchword+'&col='+colfrom+'&s=s')" 
										v-html="resultHitList[index].hitPara[0].text.replace(/color:Red/g,'color:#bd1a2d;')">
									</a>
								</dd>
							</dl>
							<dl v-else style="margin-bottom: 16px;">
								<dd >
									
								</dd>
							</dl>
							<dl>
								<dd style="line-height: 1;">
									<R style="color: #a1a4ab;margin-left: 0px;top:0px;">{{result.publishtime?result.publishtime.substring(0,10):''}}</R>
								</dd>
								<R v-if="result.exattribute8">
									<btn name="D_zcjd" @click="showZCJD(result.id)">
										<icon class="icon-news"></icon>政策解读
									</btn>
								</R>
							</dl>
						</section>
					</div>
					
					<div v-if="pageNum==1" class="footerBar">
						<div class="splitline1"></div>
					  <!-- <span></span> -->
					  <a @click="showfankui">
							<span>不是期望的结果？提交反馈</span>
							<div style="display: inline-block;">
								<a class="fankuibutton"></a>
							</div>
						</a>
						<div class="splitline1"></div>
					</div>
					
					<div class="pagediv">
						<el-pagination @size-change="changePageSize" @current-change="changeSearchPage"
							:current-page="pageNum" :page-sizes="[10, 15, 20]" :page-size="pageSize"
							layout="total, sizes, prev, pager, next, jumper" :total="totalResultCount">
						</el-pagination>
					</div>
				</div>
			</div>
			<!-- 检索无数据 开始-->
			<div v-else class="search_none">
				<img src="/images/search_none_img1.png" width="293" height="238" alt="" />
				<h5>抱歉~暂无数据，可尝试更换关键字~</h5>
			</div>
			<!-- 检索无数据 结束-->
		</div>
		
		
		<div class="zcjdpanel _popRight"  id="policy_pop" style="display: block;" v-show="zcjdPanelVisible"><!-- policy_interpret -->
			<div class="pop_right"><!-- pop_right -->
				<div class="pop_right_header"><btn class="pop_right_close" @click="hideZCJD" name="pop-close"></btn></div>
				<div class="pop_right_main" v-loading="loadingMaskZcjd"><!-- main -->
					
					<ul class="policy_list">
						<li v-for="(item,index) in zcjdresultDataList">
							<div class="tit">
								<a target="_blank" @click="jumppush('/detail/'+item.id+'?s=s')" style="font-weight: bold;">
									{{item.articletitle}}</a>
								</div>
							<div class="txt">{{item.summary.length>80?item.summary.substring(0,80)+'...':item.summary}}</div>
							<div class="date">{{item.publishtime?item.publishtime.substring(0,10):''}}</div>
						</li>
					</ul>
					
				</div><!-- /main -->
				<div style="margin-bottom: 32px;">
						<el-row class="pagediv">
							<el-pagination @current-change="zcjdchangeSearchPage" :current-page="zcjdpageNum" :page-size="10"
								layout="total, prev, pager, next" :total="zcjdtotalResultCount">
							</el-pagination>
						</el-row>
				</div>
				<div class="pop_right_footer">
						
				</div>
			</div><!-- /pop_right -->
			<div class="pop_bg" style="display: block;" @click="hideZCJD"></div>
		</div><!-- /policy_interpret -->
	</div>

</template>

<script>
	export default {
		data() {
			return {
				textshow: false,
				resultshow: false,
				showsugflag: false,
				sugstaytimer: '',
				sugwordsList: [],
				loadingMask: false,
				searchType: '1',
				searchColum: '',
				searchword: '',
				keyword: '',
				cachekeyword: '',
				pageNum: 1,
				pageSize: 10,
				totalResultCount: '',
				resultDataList: [],
				resultHitList: [],
				datePanelVisible: false,
				dateType: 0,
				dateTypeText: '时间不限',
				searchdate: '',
				dateStr: '',
				zcjdPanelVisible: false,
				zcjdpageNum: 1,
				zcjdtotalResultCount: 0,
				zcjdresultDataList: [],
			}
		},
		props: [
			'colid',
			'colname',
			'colfrom',
			'iszhuanti'
		],
		mounted: function() {
			if(this.iszhuanti){
				this.textshow=true;
			}
		},
		watch: {

		},
		methods: {
			jumppush:function(to){
				var a = document.createElement('a');
				a.setAttribute('href', to);
				a.setAttribute('style', 'display:none');  
				a.setAttribute('target', '_blank');  
				document.body.appendChild(a);
				a.click();
				a.parentNode.removeChild(a); 
			},
			showSearch: function() {
				this.textshow = true;
				this.$track([
					['pagetype',this.colname+'-栏目内检索-点击'],
				]);
			},
			showSearchResult: function() {
				this.resultshow = true;
				this.$emit('searchshow');
			},
			closeSearch: function() {
				this.clearword();
				this.textshow = false;
				this.resultshow = false;
				this.$emit('searchclose');
			},
			clearword: function() {
				this.keyword = '';
				this.cachekeyword = '';
			},
			showsug: function(fromflag) {
				if (this.keyword) {
					if (this.cachekeyword != this.keyword) {
						this.getsugfnc();
						this.showsugflag = true;
					}
					if(fromflag){
						this.showsugflag = true;
					}
				} else {
					this.cachekeyword = '';
					this.showsugflag = false;
				}
			},
			hidesug: function() {
				this.showsugflag = false;
			},
			getsugfnc: function() {
				if (this.keyword) {
					let _this = this;
					this.cachekeyword = this.keyword;
					this.$http({
							method: 'get',
							url: 'SearchInfo/SugHotWordListInfo',
							responseType: 'json',
							params: {
								sugKey: this.keyword,
							},
						})
						.then(function(response) {
							// debugger;
							_this.sugwordsList = response.data.data.data;
							clearTimeout(_this.sugstaytimer);
							_this.sugstaytimer = setTimeout(function() {
								if (_this.showsugflag && _this.sugwordsList.length > 0) {
									_this.$track([
										['pagetype', 'sug提示'],
										['searchkeyword', _this.sugwordsList.join(' ')]
									]);
								}
							}, 2000);
							if (_this.sugwordsList.length < 1) {
								_this.showsugflag = false;
							}
						})
						.catch(function(error) {
							console.log(error);
						});
				}
			},
			showDatePanel: function() {
				this.$track([
					['pagetype',this.colname+'-栏目内检索-时间筛选-点击'],
				]);
				this.datePanelVisible = true;
				let _this = this;
				var listenerfunc = function(e) {
					if (!document.getElementById('datePanelDiv').contains(e.target)) {
						_this.datePanelVisible = false;
						document.removeEventListener('click', listenerfunc);
					}
				}
				document.addEventListener('click', listenerfunc)
			},
			dateClick(value, name) {
				// debugger
				if (value == 4 && !this.dateStr) {
					return false;
				}
				this.dateType = value;
				this.dateTypeText = name;
				this.datePanelVisible = false;
				this.pageNum = 1;
				if(this.dateType==4){
					this.$track([
						['pagetype',this.colname+'-栏目内检索-时间筛选-自定义:'+this.dateStr[0] + '#' + this.dateStr[1]+'-点击'],
					]);
				}
				else{
					this.$track([
						['pagetype',this.colname+'-栏目内检索-时间筛选-'+this.dateTypeText+'-点击'],
					]);
				}
				this.searchfnc();
			},
			selhistory: function(key) {
				this.keyword = key;
				this.searchClick();
			},
			searchClick: function() {
				this.searchword = this.keyword;
				this.$track([
					['pagetype', this.colname + '栏目搜索'],
					['searchkeyword', this.searchword]
				]);
				if (this.searchword) {
					this.searchColum = this.colid;
					this.pageNum = 1;
					this.pageSize = 10;
					this.dateType = 0;
					this.dateTypeText = '时间不限';
					this.searchfnc();
					this.showSearchResult();
					this.hidesug();
				}
			},
			searchfnc: function() {
				// debugger
				let _this = this;
				_this.loadingMask = true;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'SearchInfo/searchListInfoByColumnAndKey',
						responseType: 'json',
						params: {
							lstkey: this.searchword,
							iPageNum: this.pageNum,
							iPageSize: this.pageSize,
							ColID: this.searchColum,
							dateType: this.dateType,
							dateStr: (this.dateType == 4 && this.dateStr && this.dateStr.length > 1) ? (this
								.dateStr[0] + '#' + this.dateStr[1]) : '',
						},
					})
					.then(function(response) {
						if (response.data.data) {
							_this.resultDataList = response.data.data.data?response.data.data.data.tempResult.artLst:[];
							_this.resultHitList = response.data.data.data?response.data.data.data.tempResult.dataList:[];
							_this.totalResultCount = response.data.data.data?response.data.data.data.tempResult.totalCount:0;
							if (_this.totalResultCount == 0) {
								_this.$track([
									['pagetype', _this.colname + '栏目搜索为空'],
									['searchkeyword', _this.searchword]
								]);
							}
						} else {

						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});;
			},
			changePageSize: function(pagesize) {
				this.pageSize = pagesize;
				this.searchfnc();
			},
			changeSearchPage: function(page) {
				// console.log(page);
				this.pageNum = page;
				this.searchfnc();
				document.body.scrollTop = 0;
				document.documentElement.scrollTop = 0;
			},
			showZCJD: function(artid) {
				this.zcjdsearchfnc(artid);
				this.zcjdPanelVisible = true;
				document.getElementsByTagName('body')[0].style.overflowY='hidden';
			},
			hideZCJD: function(artid) {
				this.zcjdPanelVisible = false;
				document.getElementsByTagName('body')[0].style.overflowY='auto';
			},
			zcjdsearchfnc: function(artid) {
				let _this = this;
				let _artid = artid;
				_this.loadingMaskZcjd=true;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'SearchInfo/artRelListInfo',
						responseType: 'json',
						params: {
							artID: artid,
							iPageNum: this.zcjdpageNum,
							iPageSize: 10,
						},
					})
					.then(function(response) {
						_this.zcjdresultDataList = response.data.data.data.tempResult.artLst;
						_this.zcjdtotalResultCount = response.data.data.data.tempResult.totalCount;
						_this.$track([
							['pagetype','政策解读'],
							['reqtype','1'],
							['pageid',_artid]
						]);
						_this.loadingMaskZcjd=false;
					})
					.catch(function(error) {
						console.log(error);
						_this.loadingMaskZcjd=false;
					});
			},
			zcjdchangeSearchPage: function(page) {
				// console.log(page);
				this.zcjdpageNum = page;
				this.zcjdsearchfnc();
			},
			showfankui:function(){
				this.$emit('showzixunjianyifromsearch');
			}
		}
	}
</script>

<style>
</style>
